import { useStudentUnreadCount } from './useStudentConversations';
import { useTeamUnreadCount } from './useTeamUnread';

/**
 * Messages non lus, équipe et élèves réunis : la pastille unique de l'onglet
 * « Messages ». `messagesOpen` : l'écran « Messages » est affiché.
 */
export function useUnreadMessages(messagesOpen: boolean): number {
  return useTeamUnreadCount(messagesOpen) + useStudentUnreadCount();
}
